module.exports = {
    controller: quotaFormController,
    templateUrl: 'quota/components/quota-form.html'
};

quotaFormController.$inject = [
    'applicationStateService',
    'quotaDataService',
    'countryDataService'
];

function quotaFormController(
    state, 
    quotaDataService,
    countryDataService
) {
    var vm = {
        $onInit: attached,
        service: quotaDataService,
        ergaOmnesCountries: [],
        loadQuotas: loadQuotas,
        countryPickerSelectionChanged: countryPickerSelectionChanged,
        clearCommodityCode: clearCommodityCode,
        clearOrderNumber: clearOrderNumber
    }
    
    function attached() {
        vm.loadQuotas();
        var countryQuery = {
            referenceCountry: 'EU',
            regionCode: '1011'
        };
        countryDataService
            .getCountries(countryQuery)
            .then(countries => countryDataService.transformCountriesForCountryPicker(countries))
            .then(countries => {
                vm.ergaOmnesCountries = countries;
            });
    }

    function loadQuotas() {
        vm.service.filter.PageNumber = 1;
        quotaDataService.getQuotas();
    }

    function countryPickerSelectionChanged(country) {
        if(country) {
            vm.service.filter.countryCode = country.code;
        }
        else {
            vm.service.filter.countryCode = null;
        }
    }

    function clearCommodityCode() {
        vm.service.filter.goodsCode = null;
    }

    function clearOrderNumber() {
        vm.service.filter.orderNumber = null;
    }

    return vm;
}